<div class="tarefas-empresa-page">
  <app-page-hero
    icone="task_alt"
    titulo="Tarefas por Empresa"
    [badge]="totalTarefas"
    [subtitulo]="'Acompanhe suas tarefas em ' + totalCompanies + ' empresa(s).'"
  >
    <button class="btn-hero" type="button" (click)="criarTarefa()">
      <mat-icon>add</mat-icon>
      Criar tarefa
    </button>
  </app-page-hero>

  <nav class="abas">
    <button
      *ngFor="let aba of abas"
      type="button"
      class="aba"
      [class.ativa]="abaAtiva === aba.key"
      (click)="selecionarAba(aba.key)"
    >
      {{ aba.label }}
      <span class="contador" *ngIf="counters[aba.key]">{{ counters[aba.key] }}</span>
    </button>
  </nav>

  <section class="filtros">
    <app-filtro-select
      [value]="filtros.targetCompanyID"
      [options]="empresas"
      (valueChange)="filtros.targetCompanyID = $event; onFiltroChange()"
    ></app-filtro-select>

    <app-filtro-responsavel
      [value]="filtros.responsibleID"
      [incluirTodos]="true"
      (valueChange)="filtros.responsibleID = $event ?? 0; onFiltroChange()"
      (responsaveisCarregados)="onResponsaveisCarregados($event)"
    ></app-filtro-responsavel>

    <app-filtro-periodo
      [intervaloSelecionado]="intervaloPeriodo"
      (intervaloSelecionadoChange)="onPeriodoChange($event)"
    ></app-filtro-periodo>

    <app-filtro-select
      [value]="filtros.moduleID"
      [options]="modulos"
      (valueChange)="filtros.moduleID = $event; onFiltroChange()"
    ></app-filtro-select>

    <app-filtro-select
      [value]="filtros.actionID"
      [options]="acoes"
      (valueChange)="filtros.actionID = $event; onFiltroChange()"
    ></app-filtro-select>

    <app-filtro-busca-texto
      [value]="filtros.name ?? ''"
      placeholder="Buscar por empresa"
      (valueChange)="onBuscaChange($event)"
    ></app-filtro-busca-texto>
  </section>

  <app-filtros-aplicados
    [tags]="tagsFiltros"
    [mostrarLimpar]="todosFiltrosSelecionados"
    (remover)="removerFiltro($event.key)"
    (limpar)="limparFiltros()"
  ></app-filtros-aplicados>

  <app-common-loader *ngIf="carregando"></app-common-loader>

  <div class="estado-vazio" *ngIf="!carregando && !grupos.length">
    <span class="estado-vazio-icone">
      <mat-icon>task_alt</mat-icon>
    </span>

    <h3>{{ temFiltrosAplicados ? 'Nenhuma tarefa encontrada' : 'Você não tem tarefas criadas' }}</h3>
    <p>
      {{
        temFiltrosAplicados
          ? 'Tente ajustar ou limpar os filtros para ver mais resultados.'
          : 'Crie tarefas para acompanhar o relacionamento com as empresas da sua carteira.'
      }}
    </p>

    <button
      *ngIf="temFiltrosAplicados"
      type="button"
      class="btn-estado-vazio"
      (click)="limparFiltros()"
    >
      <mat-icon>filter_alt_off</mat-icon>
      Limpar filtros
    </button>

    <button
      *ngIf="!temFiltrosAplicados"
      type="button"
      class="btn-estado-vazio"
      (click)="criarTarefa()"
    >
      <mat-icon>add</mat-icon>
      Criar tarefa
    </button>
  </div>

  <section class="grupos" *ngIf="!carregando && grupos.length">
    <div class="grupo-empresa" *ngFor="let grupo of grupos">
      <div class="grupo-header">
        <div
          class="grupo-info grupo-info-link"
          role="link"
          tabindex="0"
          (click)="abrirEmpresa(grupo)"
          (keydown.enter)="abrirEmpresa(grupo)"
        >
          <span class="avatar">
            <img
              *ngIf="grupo.companyLogoImage"
              [src]="logoUrl(grupo)"
              [alt]="grupo.companyTradeName"
            />
            <ng-container *ngIf="!grupo.companyLogoImage">
              {{ iniciais(grupo.companyTradeName) }}
            </ng-container>
          </span>
          <div>
            <h2>
              {{ grupo.companyTradeName }}
              <span class="badge-tarefas">{{ grupo.tarefas.length }} tarefa(s)</span>
            </h2>
            <p>{{ grupo.companyName }} — {{ grupo.city }}/{{ grupo.state }}</p>
          </div>
        </div>
        <button type="button" class="btn-abrir-empresa" (click)="abrirEmpresa(grupo)">
          <mat-icon>business</mat-icon> Abrir empresa
        </button>
      </div>

      <div class="tabela-wrapper">
      <table class="tabela-tarefas">
        <colgroup>
          <col class="col-data" />
          <col class="col-nome" />
          <col class="col-cargo" />
          <col class="col-telefones" />
          <col class="col-emails" />
          <col class="col-acao" />
          <col class="col-responsavel" />
          <col class="col-status" />
          <col class="col-anotacao" />
          <col class="col-acoes" />
        </colgroup>
        <thead>
          <tr>
            <th appThOrdenavel="followUpFormat" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">DATA</th>
            <th appThOrdenavel="contactName" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">NOME</th>
            <th appThOrdenavel="contactPosition" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">CARGO</th>
            <th appThOrdenavel="contactPhones" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">TELEFONE</th>
            <th appThOrdenavel="contactEmail" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">E-MAIL</th>
            <th appThOrdenavel="actionDescription" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">AÇÃO</th>
            <th appThOrdenavel="responsibleName" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">RESPONSÁVEL</th>
            <th appThOrdenavel="statusDescription" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">STATUS</th>
            <th appThOrdenavel="description" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">ANOTAÇÕES</th>
            <th>AÇÕES</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let tarefa of grupo.tarefas">
            <td [title]="tarefa.followUpFormat">{{ tarefa.followUpFormat }}</td>
            <td class="celula-nome" [title]="tarefa.contactName">{{ tarefa.contactName }}</td>
            <td [title]="tarefa.contactPosition">{{ tarefa.contactPosition }}</td>
            <td [title]="(tarefa.contactPhones || []).join(', ')">
              {{ (tarefa.contactPhones || []).join(', ') }}
            </td>
            <td [title]="tarefa.contactEmail">{{ tarefa.contactEmail }}</td>
            <td [title]="tarefa.actionDescription">
              <span
                class="tag-acao"
                [ngClass]="classeAcao(tarefa.actionDescription)"
                *ngIf="tarefa.actionDescription"
              >
                {{ tarefa.actionDescription }}
              </span>
            </td>
            <td [title]="tarefa.responsibleName">{{ tarefa.responsibleName }}</td>
            <td>
              <span class="status" [class]="classeStatus(tarefa.statusDescription)">
                {{ tarefa.statusDescription }}
              </span>
            </td>
            <td [title]="tarefa.description">{{ tarefa.description }}</td>
            <td class="acoes">
              <button
                type="button"
                class="btn-excluir-tarefa"
                title="Excluir tarefa"
                (click)="excluirTarefa(tarefa)"
              >
                <mat-icon>delete_outline</mat-icon>
              </button>
              <button
                type="button"
                class="btn-concluir-tarefa"
                title="Concluir tarefa"
                (click)="concluirTarefa(tarefa)"
                *ngIf="tarefa.statusId !== 3"
              >
                <mat-icon>check</mat-icon>
              </button>
              <button
                type="button"
                class="btn-editar-tarefa"
                title="Editar tarefa"
                (click)="editarTarefa(tarefa)"
              >
                <mat-icon>edit_note</mat-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      </div>
    </div>

    <app-paginacao-tarefas
      *ngIf="recordsCount > pageSize"
      [paginacao]="{
        page: page,
        pageFirst: 1,
        pageLast: pageLast,
        pageNext: page < pageLast ? page + 1 : page,
        pagePrev: page > 1 ? page - 1 : page,
        recordsCount: recordsCount,
        pageActive: true,
        pageSize: pageSize,
        shortcuts: 0,
        hasValue: recordsCount > 0,
        shortcutPages: [],
        records: []
      }"
      (paginaMudada)="onPageChange($event)"
    ></app-paginacao-tarefas>
  </section>
</div>

<app-modal-mensagem
  *ngIf="modalMensagem"
  [tipo]="modalMensagem.tipo"
  [titulo]="modalMensagem.titulo"
  [mensagem]="modalMensagem.mensagem"
  [textoConfirmar]="modalMensagem.textoConfirmar"
  [exibirCancelar]="modalMensagem.exibirCancelar"
  [corConfirmar]="modalMensagem.corConfirmar"
  (confirmar)="onConfirmarModalMensagem()"
  (cancelar)="onCancelarModalMensagem()"
></app-modal-mensagem>
